export default "__VITE_ASSET__ObD6sQu8__"